import Vue from "vue";
import Router from "vue-router";
import store from "../store/store";
//CHN pages
const ChinesePreTest = () =>
    import ("@/view/Chinese");
const LessonSelect = () =>
    import ("@/view/chineseScreen/LessonSelect");
const HP02 = () =>
    import ("@/view/chineseScreen/HP02");
const HP03 = () =>
    import ("@/view/chineseScreen/HP03");
const CTA01 = () =>
    import ("@/view/chineseScreen/CTA01");
const CTA02 = () =>
    import ("@/view/chineseScreen/CTA02");
const CTA04 = () =>
    import ("@/view/chineseScreen/CTA04");
const CTA05 = () =>
    import ("@/view/chineseScreen/CTA05");
const CTT01 = () =>
    import ("@/view/chineseScreen/CTT01");
const CTT02 = () =>
    import ("@/view/chineseScreen/CTT02");
const CTT04 = () =>
    import ("@/view/chineseScreen/CTT04");
const IAM01 = () =>
    import ("@/view/chineseScreen/IAM01");
const IAM05 = () =>
    import ("@/view/chineseScreen/IAM05");
const IAM08 = () =>
    import ("@/view/chineseScreen/IAM08");
const LKA01 = () =>
    import ("@/view/chineseScreen/LKA01");
const LKI01 = () =>
    import ("@/view/chineseScreen/LKI01");
const LKS01 = () =>
    import ("@/view/chineseScreen/LKS01");
const LKT01 = () =>
    import ("@/view/chineseScreen/LKT01");
const LKT03 = () =>
    import ("@/view/chineseScreen/LKT03");
const LKT04 = () =>
    import ("@/view/chineseScreen/LKT04");
const CTV01 = () =>
    import ("@/view/chineseScreen/CTV01");
const Test = () =>
    import ("@/view/CHN");

const ifAuthenticated = (to, from, next) => {
    if (store.getters["auth/userStatus"]) {
        store.dispatch("template/setLangOption", true)
        next();
    } else {
        next('/homepage')
    }
}
export default [
    // chinese route template
    {
        path: "/test/:id",
        name: "Test",
        component: Test,
    },
    {
        path: "/chinese",
        name: "Chinese",
        component: ChinesePreTest,
        beforeEnter: ifAuthenticated
    },
    {
        path: "/HP01/:id",
        name: "HP01",
        component: LessonSelect,
        beforeEnter: ifAuthenticated
    },
    {
        path: "/HP02/:id",
        name: "HP02",
        component: HP02,
        beforeEnter: ifAuthenticated
    },
    {
        path: "/HP03/:id",
        name: "HP03",
        component: HP03,
        beforeEnter: ifAuthenticated
    },
    {
        path: "/CTA01/:id",
        name: "CTA01",
        component: CTA01,
        beforeEnter: ifAuthenticated
    },
    {
        path: "/CTA02/:id",
        name: "CTA02",
        component: CTA02,
        beforeEnter: ifAuthenticated
    },
    {
        path: "/CTA04/:id",
        name: "CTA04",
        component: CTA04,
        beforeEnter: ifAuthenticated
    },
    {
        path: "/CTA05/:id",
        name: "CTA05",
        component: CTA05,
        beforeEnter: ifAuthenticated
    },
    {
        path: "/CTT01/:id",
        name: "CTT01",
        component: CTT01,
        beforeEnter: ifAuthenticated
    },
    {
        path: "/CTT02/:id",
        name: "CTT02",
        component: CTT02,
        beforeEnter: ifAuthenticated
    },
    {
        path: "/CTT04/:id",
        name: "CTT04",
        component: CTT04,
        beforeEnter: ifAuthenticated
    },
    {
        path: "/IAM01/:id",
        name: "IAM01",
        component: IAM01,
        beforeEnter: ifAuthenticated
    },
    {
        path: "/IAM05/:id",
        name: "IAM05",
        component: IAM05,
        beforeEnter: ifAuthenticated
    },
    {
        path: "/IAM08/:id",
        name: "IAM08",
        component: IAM08,
        beforeEnter: ifAuthenticated
    },
    {
        path: "/LKA01/:id",
        name: "LKA01",
        component: LKA01,
        beforeEnter: ifAuthenticated
    },
    {
        path: "/LKI01/:id",
        name: "LKI01",
        component: LKI01,
        beforeEnter: ifAuthenticated
    },
    {
        path: "/LKS01/:id",
        name: "LKS01",
        component: LKS01,
        beforeEnter: ifAuthenticated
    },
    {
        path: "/LKT01/:id",
        name: "LKT01",
        component: LKT01,
        beforeEnter: ifAuthenticated
    },
    {
        path: "/LKT03/:id",
        name: "LKT03",
        component: LKT03,
        beforeEnter: ifAuthenticated
    },
    {
        path: "/LKT04/:id",
        name: "LKT04",
        component: LKT04,
        beforeEnter: ifAuthenticated
    },
    {
        path: "/CTV01/:id",
        name: "CTV01",
        component: CTV01,
        beforeEnter: ifAuthenticated
    },
]